import React from "react";
import { motion } from "framer-motion";
import { Ghost as GhostIcon } from "lucide-react";

const chapters = [
  {
    n: "01",
    title: "Zaczynamy od dziecięcych oczu",
    body:
      "Każda historia Tonka i Duszka rodzi się z pytania, które dziecko zadaje po raz pierwszy. Chronimy tę ciekawość, nie tłumimy jej pouczaniem.",
  },
  {
    n: "02",
    title: "Rysujemy miękkimi kredkami",
    body:
      "Nasze książki i animacje mają zaokrąglone kształty, pastelową paletę i miejsca, w których wyobraźnia może wpaść i chwilę pobyć.",
  },
  {
    n: "03",
    title: "Piszemy tak, jak się szepcze",
    body:
      "Krótkie zdania. Duże serca. Żadnych morałów wbijanych młotkiem. Duszek nie moralizuje — on pyta, słucha i lata dalej.",
  },
  {
    n: "04",
    title: "Zostawiamy miejsce na sny",
    body:
      "Każda historia kończy się na moment przed puentą. To dziecko dopowiada finał — bo jego wyobraźnia zawsze wie lepiej.",
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

const item = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export default function Manifest() {
  return (
    <section
      id="manifest"
      className="relative py-28 md:py-40 overflow-hidden"
      data-testid="manifest-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="flex items-end justify-between mb-20 md:mb-28"
        >
          <div>
            <span className="chip mb-6" data-testid="manifest-eyebrow">
              <span className="dot" /> Manifest
            </span>
            <h2 className="font-display font-semibold text-[#051937] text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-3xl mt-6">
              Cztery zasady, według których <em className="not-italic text-[#60A5FA]">Tonek i Duszek</em>{" "}
              opowiadają świat.
            </h2>
          </div>
          <GhostIcon size={64} className="hidden md:block text-[#84C5F4]" />
        </motion.div>

        <motion.ol
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="space-y-20 md:space-y-28"
        >
          {chapters.map((c, i) => (
            <motion.li
              key={c.n}
              variants={item}
              className="grid grid-cols-12 gap-6 md:gap-10 items-start"
              data-testid={`manifest-chapter-${c.n}`}
            >
              <div className="col-span-12 md:col-span-4">
                <div className="chapter-number text-[8rem] md:text-[12rem] text-[#FDE68A] select-none">
                  {c.n}
                </div>
              </div>
              <div
                className={`col-span-12 md:col-span-7 ${
                  i % 2 === 1 ? "md:col-start-6" : "md:col-start-5"
                }`}
              >
                <h3 className="font-display font-semibold text-[#051937] text-2xl sm:text-3xl lg:text-4xl leading-tight tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-5 text-lg text-[#0b2a55]/80 leading-relaxed max-w-lg">
                  {c.body}
                </p>
              </div>
            </motion.li>
          ))}
        </motion.ol>
      </div>
    </section>
  );
}
